import React from "react";
import { useTranslation } from "react-i18next";
import "./Footer.css";

function Footer() {
  const { t } = useTranslation("Footer");

  return (
    <footer className="tracking-app-footer" data-testid="footer">
      <div className="links">
        <a className="footer-link" href={t("Footer:LegalNoticeLink")}>
          {t("LegalNotice")}
        </a>
        <a className="footer-link" href={t("Footer:DataPrivacyLink")}>
          {t("DataProtection")}
        </a>
        <a className="footer-link" href={t("HelpLink")}>
          {t("Help")}
        </a>
      </div>
      <div className="tracking-app-footer-terms">
        {t("Cookie:TermsOfUseTextPre")}
      </div>
    </footer>
  );
}

export default Footer;
